import { cn } from '@/lib/utils'
import MarkerText from './MarkerText'
import AssignmentReminderTimeBadge from './AssignmentReminderTimeBadge'

type Props = {
  text?: string
  color?: string
  offsetSeconds?: number
  cascadeSeconds?: number
  className?: string
}

const AssignmentScopeReminderText = ({
  text,
  color,
  offsetSeconds,
  cascadeSeconds,
  className,
}: Props) => {
  if (!text) return null
  return (
    <span
      className={cn(
        'ml-2 inline-flex min-w-[10rem] max-w-full items-center gap-1 overflow-hidden align-middle',
        !color && 'text-info-foreground',
        className,
      )}
      style={color ? { color } : undefined}
      title={text}
    >
      <span className='min-w-0 truncate'>
        &quot;
        <MarkerText text={text} />
        &quot;
      </span>
      <AssignmentReminderTimeBadge
        offsetSeconds={offsetSeconds}
        cascadeSeconds={cascadeSeconds}
      />
    </span>
  )
}

export default AssignmentScopeReminderText
